<template>
  <vxe-modal
    ref="modal"
    size="mini"
    v-model="formVisible"
    title="选择职位"
    width="300px"
    @show="showModal"
  >
    <el-select
      clearable
      :multiple="isMultiple"
      v-model="post"
      size="small"
      placeholder="请选择"
    >
      <el-option
        v-for="i of positionOptions"
        :key="i.name + ''"
        :label="i.name"
        :value="i.value"
      ></el-option>
    </el-select>
    <el-button
      @click="handleCommit"
      style="float: right; margin-top: 10px"
      size="mini"
      type="primary"
      >确认</el-button
    >
  </vxe-modal>
</template>
<script>
export default {
  props: {
    visiblePosition: {
      type: Array,
      default: () => {
        return []
      }
    },
    positionOptions: {
      type: Array,
      default: () => {
        return []
      }
    },
    isMultiple: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      formVisible: false,
      post: []
    }
  },
  methods: {
    showModal () {
      this.post = this.visiblePosition
    },
    handleCommit () {
      if (this.isMultiple) {
        this.$emit("sureBackPosition", this.post.join(","));
      } else {
        this.$emit("sureBackPosition", this.post);
      }
      this.$nextTick(() => {
        this.formVisible = false
      })
    },
  },
}
</script>
<style lang='less' scoped>
// vxemodal部分，美化标题太大的问题
/deep/ .vxe-modal--header {
  // font-size: 12px !important;
  height: 26px !important;
  padding: 2px 10px 0 10px !important;
}

// vxemodal关闭按钮
/deep/ .vxe-modal--close-btn {
  position: absolute !important;
  right: 8px !important;
  top: 6px !important;
  z-index: 1 !important;
  cursor: pointer !important;
}

// vxemodal标题
/deep/ .vxe-modal--title {
  font-size: 12px !important;
}
</style>